import React, { Fragment } from 'react'
import {
    List,
    Datagrid,
    NumberField,
    TextField,
} from 'react-admin'

import Title from '../Generic/Title'

export const RegionList = ({ permissions, ...props }) => {
    if (permissions === null) return null
    return (
        <Fragment>
            <Title title={"Regiones"} />
            <List {...props} sort={{ field: 'id', order: 'ASC' }} exporter={false} >
                <Datagrid rowClick="edit">
                    <NumberField source="id" />
                    <NumberField source="code" label="Código" />
                    <TextField source="name" label="Nombre"/>
                    <TextField source="full_name" label="Nombre Largo"/>
                </Datagrid>
            </List>
        </Fragment>
    )
}
